'use strict';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var Any = require('./any');
var Common = require('../common');
var Compile = require('../compile');
var Errors = require('../errors');
var internals = {};
module.exports = Any.extend({
  type: 'link',
  properties: {
    schemaChain: true
  },
  terms: {
    link: {
      init: null,
      manifest: 'single',
      register: false
    }
  },
  args: function args(schema, ref) {
    return schema.ref(ref);
  },
  validate: function validate(value, _ref) {
    var schema = _ref.schema,
      state = _ref.state,
      prefs = _ref.prefs;
    Assert(schema.$_terms.link, 'Uninitialized link schema');
    var linked = internals.generate(schema, value, state, prefs);
    var ref = schema.$_terms.link[0].ref;
    return linked.$_validate(value, state.nest(linked, "link:".concat(ref.display, ":").concat(linked.type)), prefs);
  },
  generate: function generate(schema, value, state, prefs) {
    return internals.generate(schema, value, state, prefs);
  },
  rules: {
    ref: {
      method: function method(ref) {
        Assert(!this.$_terms.link, 'Cannot reinitialize schema');
        ref = Compile.ref(ref);
        Assert(ref.type === 'value' || ref.type === 'local', 'Invalid reference type:', ref.type);
        Assert(ref.type === 'local' || ref.ancestor === 'root' || ref.ancestor > 0, 'Link cannot reference itself');
        var obj = this.clone();
        obj.$_terms.link = [{
          ref: ref
        }];
        return obj;
      }
    },
    relative: {
      method: function method() {
        var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return this.$_setFlag('relative', enabled);
      }
    }
  },
  overrides: {
    concat: function concat(source) {
      Assert(this.$_terms.link, 'Uninitialized link schema');
      Assert(Common.isSchema(source), 'Invalid schema object');
      Assert(source.type !== 'link', 'Cannot merge type link with another link');
      var obj = this.clone();
      if (!obj.$_terms.whens) {
        obj.$_terms.whens = [];
      }
      obj.$_terms.whens.push({
        concat: source
      });
      return obj.$_mutateRebuild();
    }
  },
  manifest: {
    build: function build(obj, desc) {
      Assert(desc.link, 'Invalid link description missing link');
      return obj.ref(desc.link);
    }
  }
});

// Helpers

internals.generate = function (schema, value, state, prefs) {
  var linked = state.mainstay.links.get(schema);
  if (linked) {
    return linked._generate(value, state, prefs).schema;
  }
  var ref = schema.$_terms.link[0].ref;
  var _internals$perspectiv = internals.perspective(ref, state),
    perspective = _internals$perspectiv.perspective,
    path = _internals$perspectiv.path;
  internals.assert(perspective, 'which is outside of schema boundaries', ref, schema, state, prefs);
  try {
    linked = path.length ? perspective.$_reach(path) : perspective;
  } catch (ignoreErr) {
    internals.assert(false, 'to non-existing schema', ref, schema, state, prefs);
  }
  internals.assert(linked.type !== 'link', 'which is another link', ref, schema, state, prefs);
  if (!schema._flags.relative) {
    state.mainstay.links.set(schema, linked);
  }
  return linked._generate(value, state, prefs).schema;
};
internals.perspective = function (ref, state) {
  if (ref.type === 'local') {
    var _iterator = _createForOfIteratorHelper(state.schemas),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _step.value,
          schema = _step$value.schema,
          key = _step$value.key;
        // From parent to root
        var id = schema._flags.id || key;
        if (id === ref.path[0]) {
          return {
            perspective: schema,
            path: ref.path.slice(1)
          };
        }
        if (schema.$_terms.shared) {
          var _iterator2 = _createForOfIteratorHelper(schema.$_terms.shared),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var shared = _step2.value;
              if (shared._flags.id === ref.path[0]) {
                return {
                  perspective: shared,
                  path: ref.path.slice(1)
                };
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return {
      perspective: null,
      path: null
    };
  }
  if (ref.ancestor === 'root') {
    return {
      perspective: state.schemas[state.schemas.length - 1].schema,
      path: ref.path
    };
  }
  return {
    perspective: state.schemas[ref.ancestor] && state.schemas[ref.ancestor].schema,
    path: ref.path
  };
};
internals.assert = function (condition, message, ref, schema, state, prefs) {
  if (condition) {
    // Manual check to avoid generating error message on success
    return;
  }
  Assert(false, "\"".concat(Errors.label(schema._flags, state, prefs), "\" contains link reference \"").concat(ref.display, "\" ").concat(message));
};